<template>
  <div id="contact-details" class="mt-4">
    <div class="flex flex-nowrap justify-between">
      <p class="block text-sm mb-1.5 font-bold">
        Contact Information
      </p>
      <p v-if="isEmailError" class="text-error-dark text-xs font-italic mt-2">
        Required
      </p>
    </div>

    <div
      class="p-4 shadow-sm rounded bg-dark-50/50"
      :class="isEmailError ? 'border-2 border-error' : 'border border-dark-100'"
    >
      <label for="email" class="block text-sm mb-0.5">Email</label>
      <input
        id="email"
        v-model="emailValue"
        type="email"
        class="w-full p-2 border border-dark-100 shadow-sm rounded focus:outline-none focus:ring-[#0470de]/20 focus:ring-4"
        @input="updateEmail()"
      >
      <!-- Error -->
      <p v-if="isEmailError" class="text-error-dark text-xs font-italic mt-2">
        Please enter a valid email address.
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  initialEmail: string | ''
  isEmailError: boolean
}>()

const emit = defineEmits<{
  (e: 'update:email', value: string): void
}>()

const emailValue = ref(props.initialEmail)

watch(emailValue, (newValue) => {
  emit('update:email', newValue)
})

function updateEmail() {
  emit('update:email', emailValue.value)
}
</script>
